import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Header from "./components/Header/Header";
import AppRoutes from "./routes/AppRoutes";
import Toast from "./utils/Toast/Toast";

import { useAuth } from "./context/AuthContext";
import useToast from "./hooks/useToast";

import {
  handleLogin,
  handleLogout,
} from "./auth/authHandlers";

import "./App.css";

function App() {
  const { userId, user, loading } = useAuth(); // ✅ include user
  const { toast, showToast } = useToast();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>
      <Router>
        <div className="App">
          <Header
            userId={userId}
            user={user}   // ✅ FIX
            onLogin={() => handleLogin({ showToast })}
            onLogout={() => handleLogout({ showToast })}
          />

          <AppRoutes
            user={user}
            userId={userId}
            showToast={showToast}
          />
        </div>
      </Router>

      <Toast
        message={toast.message}
        type={toast.type}
        show={toast.show}
      />
    </>
  );
}

export default App;